const getWorkflowStepTabQueryKey = ({ stepId, tabKey = 'stepTab' }) => {
  if (!stepId) {
    return tabKey;
  }

  return `${tabKey}_${stepId}`;
};

export default getWorkflowStepTabQueryKey;
